import React from 'react';

import Accordion from 'react-bootstrap/Accordion';

class CompanyItem extends React.Component {
    render() {
	var company = this.props.company;
	var url = "http://" + company.url;
	
	return (
	    <Accordion.Item eventKey={company.id}>
		<Accordion.Header>{company.name} &nbsp;&nbsp;</Accordion.Header>
		<Accordion.Body>
		    {company.description}
		    <table>
			<tbody>
			    <tr>
				<td align="right"><b>Kategori:</b></td>
				<td>{company.category}</td>
			    </tr>
			    <tr>
				<td align="right"><b>Adress:</b></td>
				<td>{company.address}</td>
			    </tr>
			    <tr>
				<td align="right"><b>Ort:</b></td>
				<td>{company.city}</td>
			    </tr>
			    <tr>
				<td align="right"><b>Telefon:</b></td>
				<td>{company.tel}</td>
			    </tr>
			    <tr>
				<td align="right"><b>Hemsida:</b></td>
				<td><a href={url}>{company.url}</a></td>
			    </tr>
			</tbody>
		    </table>
		</Accordion.Body>
	    </Accordion.Item>
	);
    }
}

export default CompanyItem;
